import Vue from 'vue'
import VueRouter from 'vue-router'
import { Toast } from 'vant'
import userRoute from './modules/user'
import EquipmentRoute from './modules/Equipment'
import Purchases from './modules/Purchase'
import Login from './modules/Login'
import store from '@/store'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/QueryRecharge',
    name: 'QueryRecharge',
    component: () => import(/* webpackChunkName: "login" */ '../views/QueryRecharge/index.vue'),
    meta: { title: '卡号查询' }
  },
  {
    path: '/rechargeFlowAdd',
    name: 'rechargeFlowAdd',
    component: () => import(/* webpackChunkName: "login" */ '../views/Recharge/flowadd.vue'),
    meta: { title: '流量包充值', showBackBtn: true }
  },
  {
    path: '/packageAdd',
    name: 'packageAdd',
    component: () => import(/* webpackChunkName: "login" */ '../views/Recharge/packageAdd.vue'),
    meta: { title: '流量充值', showBackBtn: true }
  },
  {
    path: '/packageAgent',
    name: 'packageAgent',
    component: () => import(/* webpackChunkName: "login" */ '../views/Recharge/packageAgent.vue'),
    meta: { title: '优惠充值', showBackBtn: true }
  },
  {
    path: '/rechargeQryindex/:iccid',
    name: 'QueryRechargeV2',
    component: () => import(/* webpackChunkName: "about" */ '../views/QueryRecharge/index.vue'),
    meta: { title: '卡号查询V2', showBackBtn: true }
  },
  {
    path: '/',
    redirect: '/QueryRecharge'
  },
  {
    path: '/Close',
    name: 'Close',
    component: () => import(/* webpackChunkName: "login" */ '../views/Close.vue'),
    meta: { title: ' ' }
  },
  {
    path: '/Pay',
    name: 'Pay',
    component: () => import(/* webpackChunkName: "about" */ '../views/pay.vue'),
    meta: { title: ' ' }
  },
  {
    path: '/Recharge/:iccid',
    name: 'Recharge',
    component: () => import(/* webpackChunkName: "about" */ '../views/Recharge/index.vue'),
    meta: { title: '卡号信息' }
  },
  {
    path: '/Mobile/Recharge/:iccid',
    name: 'MobileRecharge',
    component: () => import(/* webpackChunkName: "about" */ '../views/loading.vue'),
    meta: { title: '卡号信息' }
  },
  {
    path: '/PayJumpOut',
    name: 'PayJumpOut',
    component: () => import(/* webpackChunkName: "content" */ '../views/Index/PayJumpOut.vue'),
    meta: { title: '点金计划' }
  },
  ...userRoute,
  ...EquipmentRoute,
  ...Purchases,
  ...Login,
  {
    path: '/index',
    component: () => import(/* webpackChunkName: "content" */ '../views/Index/index.vue'),
    redirect: '/Home',
    meta: { title: '流量平台' },
    children: [
      {
        path: '/Home',
        name: 'Home',
        component: () => import(/* webpackChunkName: "content" */ '../views/Index/modules/Home.vue'),
        meta: { title: '首页', keepAlive: true },
        beforeEnter (to, from, next) {
          const token = store.state.token
          if (!token) {
            Toast.fail('请先登录')
            next('/login/no')
          } else {
            next()
          }
        }
      },
      // { path: '/Equipment/:id', name: 'Equipment', component: () => import(/* webpackChunkName: "content" */ '../views/Index/modules/Equipment.vue'), meta: { title: '停机', keepAlive: false } },
      { path: '/SimList', name: 'SimList', component: () => import(/* webpackChunkName: "content" */ '../views/Index/modules/SimList.vue'), meta: { title: 'SIM卡', keepAlive: false } },
      { path: '/User', name: 'User', component: () => import(/* webpackChunkName: "content" */ '../views/Index/modules/User.vue'), meta: { title: '我的', keepAlive: false } }
    ]
  },
  {
    path: '/EquipmentBeyond',
    name: 'EquipmentBeyond',
    component: () => import(/* webpackChunkName: "user" */'../views/Index/modules/EquipmentBeyond.vue'),
    meta: { title: '超流量设备', showBackBtn: true }
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})
const simTitleMap = {
  1: '套餐临期',
  2: '流量不足',
  3: '流量超额',
  4: '机卡分离',
  5: '静默停机',
  default: 'SIM卡'
}

router.beforeEach((to, from, next) => {
  const pageTitle = to.meta.title
  const queryCustomTitle = to.query?.customTitle || ''
  console.log(queryCustomTitle)
  const brandName = '流量平台'
  if (!pageTitle || !to.meta.showBackBtn) {
    window.document.title = brandName
  } else if (to.name === 'SimType') {
    const type = to.params.type
    const newTitle = simTitleMap[type] || simTitleMap.default
    window.document.title = `${newTitle} | ${brandName}`
    to.meta.title = `${newTitle} | ${brandName}` // 同步更新 meta，方便导航栏组件读取
  } else if (queryCustomTitle) {
    window.document.title = `${queryCustomTitle} | ${pageTitle} | ${brandName}`
  } else {
    window.document.title = `${pageTitle} | ${brandName}`
  }
  const Flag = localStorage.getItem('FLAG')
  if (to.path === '/Pay' && Flag !== 'true') {
    next('/')
  }
  if (to.path === '/Mobile/Recharge' && !to.params.iccid) {
    Toast('请先输入卡号')
    next('/')
  }
  next()
})

router.afterEach((to, from) => {
  window.scrollTo(0, 0)
})

export default router
